import shieldIcon from "../../assets/all-icons/shield-checkmark-blue.png";
import unlockIcon from "../../assets/all-icons/lock-square-blue.png";
import documentIcon from "../../assets/all-icons/document-clipboard-dark-purple.png";
import userIcon from "../../assets/all-icons/user-profile-circle-blue.png";
import { useInView } from "../../hooks/useInView";

const FEATURES = [
  {
    icon: shieldIcon,
    iconBg: "#eff6ff",
    title: "Secure & Protected",
    description:
      "Your information is safeguarded throughout the application process.",
  },
  {
    icon: unlockIcon,
    iconBg: "#eef2ff",
    title: "Privacy First",
    description: "Your personal information is handled responsibly.",
  },
  {
    icon: documentIcon,
    iconBg: "#faf5ff",
    title: "Transparent & Clear",
    description:
      "Loan terms, applicable charges, and repayment details are clearly communicated.",
  },
  {
    icon: userIcon,
    iconBg: "#eff6ff",
    title: "Your information is secure.",
    description:
      "We use secure practices to protect your personal and financial information.",
  },
];

export function SecurityNote() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 sm:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[488fr_696fr] lg:gap-8">
        {/* Left: heading + copy */}
        <div
          ref={ref}
          className={`flex flex-col items-start gap-4 ${inView ? "in-view" : ""}`}
        >
          <span className="reveal-scroll delay-1 rounded-full bg-[#f0edfa] px-4 py-[6px] text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
            Your Data. Your Privacy. Your Trust.
          </span>
          <h2 className="reveal-scroll delay-2 text-2xl font-bold leading-tight text-[#1c1917] sm:text-3xl">
            Security Note
          </h2>
          <p className="reveal-scroll delay-3 text-sm leading-6 text-[#475569]">
            We take the security of your personal and financial information
            seriously. Your information is handled securely and used in
            accordance with our privacy practices.
          </p>
        </div>

        {/* Right: 2x2 feature grid */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {FEATURES.map((feature) => (
            <div key={feature.title} className="flex items-start gap-3">
              <span
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
                style={{ backgroundColor: feature.iconBg }}
              >
                <img src={feature.icon} alt="" className="h-4 w-4" />
              </span>
              <div>
                <p className="text-sm font-bold leading-5 text-[#1c1917]">
                  {feature.title}
                </p>
                <p className="pt-[2px] text-xs leading-4 text-[#64748b]">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Disclaimer banner */}
      <div className="mt-8 rounded-xl bg-[#fff9f2] px-4 py-[13px]">
        <p className="text-xs leading-4 text-[#9a5b1e]">
          <span className="font-semibold">Important:</span> Only use claims
          like "encrypted," "bank-grade security," "RBI regulated," etc. if
          GenzPaisa can substantiate them.
        </p>
      </div>
    </section>
  );
}
